/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import SbEditable from "storyblok-react";
import { render } from "storyblok-rich-text-react-renderer";
import { BLOK_ARRAY, COLOR, RICH_TEXT_CONTENT } from "../../../prop_types";
import {
  colorWhiteStyle,
  isCenteredStyle,
  richTextStyle,
  sizeExtraSmallStyle,
  sizeLargeStyle,
  sizeSmallStyle,
  standFirstStyle,
} from "./rich_text.module.scss";
import { RichTextBlokResolvers } from "./rich_text_render_configuration/rich_text_blok_resolvers";
import { RichTextMarkResolvers } from "./rich_text_render_configuration/rich_text_mark_resolvers";
import RichTextNodeResolver from "./rich_text_render_configuration/rich_text_node_resolvers";

export default function RichTextWithBlok({
  balanceText,
  color,
  isCentered,
  seoHeadingLevel,
  settings,
  size,
  text,
  ...rest
}) {
  const richTextClassNames = classNames(richTextStyle, {
    [isCenteredStyle]: isCentered,
    [sizeExtraSmallStyle]: size === "x-small",
    [sizeSmallStyle]: size === "small",
    [sizeLargeStyle]: size === "large",
    [standFirstStyle]: size === "xl",
    [colorWhiteStyle]: color === "white",
  });

  // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
  const style = {};

  if (color && color.color) {
    style.color = color.color;
  }

  const Element = seoHeadingLevel ? `h${seoHeadingLevel}` : "div";

  return (
    <SbEditable content={rest}>
      <Element
        data-testid="rich-text"
        className={richTextClassNames}
        style={style}
      >
        {text &&
          render(text, {
            nodeResolvers: RichTextNodeResolver({ balanceText }),
            markResolvers: RichTextMarkResolvers,
            blokResolvers: RichTextBlokResolvers,
            defaultBlokResolver: (name) => {
              // eslint-disable-next-line no-console
              console.warn(`Missing blok resolver for blok type ${name}.`);
              return null;
            },
          })}
      </Element>
    </SbEditable>
  );
}

RichTextWithBlok.propTypes = {
  balanceText: PropTypes.bool,
  color: PropTypes.oneOfType([COLOR, PropTypes.string]),
  isCentered: PropTypes.bool,
  seoHeadingLevel: PropTypes.string,
  settings: BLOK_ARRAY,
  size: PropTypes.string,
  text: PropTypes.shape({
    type: PropTypes.string,
    content: PropTypes.arrayOf(RICH_TEXT_CONTENT),
  }),
};

RichTextWithBlok.defaultProps = {
  balanceText: false,
  color: null,
  isCentered: false,
  seoHeadingLevel: null,
  settings: null,
  size: "regular",
  text: null,
};
